import React from 'react';
import { LivingDocuments } from 'components/LivingDocuments';

export const Sustainability = () => (
  <LivingDocuments category="sustainability" />
);
